import { usePutApiAdminUserCompany } from '@sit/client-shared';
import { useForm } from '@tanstack/react-form';
import Button from 'carbon-react/lib/components/button';
import { Card, CardColumn, CardRow } from 'carbon-react/lib/components/card';
import Form from 'carbon-react/lib/components/form';
import Heading from 'carbon-react/lib/components/heading';
import Loader from 'carbon-react/lib/components/loader';
import Textbox from 'carbon-react/lib/components/textbox';
import GoBackButton from '../../components/GoBackButton';
import toastr from '../../helpers/toastr';

const MultiEntity = () => {
  const mutation = usePutApiAdminUserCompany();

  const form = useForm({
    defaultValues: {
      companyId: '',
      userId: '',
    },
    onSubmit: async ({ value }) => {
      await mutation.mutateAsync(
        {
          pathParams: {
            id: value.userId,
          },
          body: {
            companyId: value.companyId,
          },
        },
        {
          onSuccess: () => {
            toastr.success('User company update successful');
            form.reset();
          },
        },
      );
    },
  });

  return (
    <div className="intacct-admin-inner-container">
      <GoBackButton />
      <Card>
        <CardRow>
          <CardColumn align="left">
            <Heading title="Update user's primary Intacct entity" mt={2} />
          </CardColumn>
        </CardRow>
        <Form
          errorCount={form.state.errors.length}
          saveButton={
            <CardRow>
              <CardColumn>
                <Button
                  buttonType="primary"
                  onClick={() => void form.handleSubmit()}
                  disabled={form.state.isSubmitting}
                >
                  {form.state.isSubmitting ? (
                    <Loader isActive isInsideButton />
                  ) : (
                    'Save'
                  )}
                </Button>
              </CardColumn>
            </CardRow>
          }
        >
          <form.Field
            name="userId"
            validators={{
              onChange: ({ value }) => {
                if (!value) return 'This field is required';
                if (value.length !== 36) return 'Must be exactly 36 characters';
                if (!/^[\da-f-]+$/.test(value))
                  return 'Must contain only hexadecimal characters and hyphens';
                return undefined;
              },
            }}
          >
            {(field) => (
              <Textbox
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                error={field.state.meta.errors[0]}
                label="User ID"
              />
            )}
          </form.Field>
          <form.Field
            name="companyId"
            validators={{
              onChange: ({ value }) => {
                if (!value) return 'This field is required';
                if (value.length !== 36) return 'Must be exactly 36 characters';
                if (!/^[\da-f-]+$/.test(value))
                  return 'Must contain only hexadecimal characters and hyphens';
                return undefined;
              },
            }}
          >
            {(field) => (
              <Textbox
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                error={field.state.meta.errors[0]}
                label="Company ID"
              />
            )}
          </form.Field>
        </Form>
      </Card>
    </div>
  );
};

export default MultiEntity;
